module.exports = __webpack_public_path__ + "static/media/anisa.774a9097.jpg";